// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ic1w","left":"InfoRow_left__3dDlt"};